/* ============================================================================
FILE: po-katupirsia9-formules-operatives-texts-fr-en-es-20260317.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK9FormulesOperativesTextsFR_EN_ES_20260317
ROOT: .po-k9-section[data-po-k9]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K9_FORMULES_OPERATIVES_TEXTS_20260317__) return;
  window.__PO_K9_FORMULES_OPERATIVES_TEXTS_20260317__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k9-section[data-po-k9="formules_operatives"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Katûvýs",
      "Katûvýsissence",
      "ÂṢẸXEL’Or",
      "Δτ",
      "Isqun",
      "Threnisqun",
      "Sceau d’Équiphase",
      "Équiphase",
      "Souffle d’Or",
      "Horloge CalAp",
      "Pulse 9:59:59",
      "Pulse 959",
      "Posœnnomia",
      "MOCoN",
      "Fréquence 492",
      "492 Hz",
      "GKSL",
      "Année posœnnoïale",
      "Épagomènes",
      "Ennéagone"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";

    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
    }
  }

  var CONTENT = {
    fr: {
      title: "Formules opératives",
      kicker: "Dossier K9 des formalismes mathématiques, physiques et cosmologiques — du Δτ à la propagation posœnnomiale.",
      title_img: { src: "", alt: "Idéogramme des Formules opératives" },

      h_def: "Définition canonique",
      chip_1: "K9 — dossier scientifique",
      chip_1_img: { src: "", alt: "Icône dossier scientifique K9" },
      chip_2: "GKSL · Δτ · mesure faible",
      chip_2_img: { src: "", alt: "Icône noyau mathématique K9" },
      chip_3: "Formules-seuils · horizons cosmologiques",
      chip_3_img: { src: "", alt: "Icône extensions et horizons" },

      def_short:
        "Les <strong>Formules opératives</strong> rassemblent, à l’intérieur du <strong>Katûpirsia 9</strong>, les écritures par lesquelles le <strong>Posœnnoïsme</strong> rend lisibles le vrai temps, la redistribution harmonique, la respiration du champ et les ouvertures vers les formalismes contemporains.",

      def_long:
        "<p>Cette page ne pose pas un concept isolé : elle ordonne un noyau de formalisation. Elle rassemble l’<strong>équation maîtresse</strong> inspirée de la forme <strong>GKSL</strong>, le régime du <strong>Δτ</strong>, la <strong>mesure faible</strong>, les profils <strong>Uniforme / Lissé / Pulsé</strong>, puis les <strong>formules-seuils</strong> qui ouvrent le système vers la <strong>Katûvýs</strong>, la <strong>Posœnnomia</strong> et l’<strong>Ennéagone</strong>.</p>" +
        "<p>Elle sert donc de chambre de lecture : non pour fermer la science sous des signes, mais pour faire respirer ensemble rigueur mathématique, modulation vibratoire, horizon cosmologique et opérativité expérimentale.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Dossier opératif K9 de formalisation scientifique et cosmologique",
      grid_freq_label: "Repères-guides",
      grid_freq_value: "Δτ · 492 Hz · Pulse 9:59:59 · 36 décades + 5 Épagomènes",
      grid_scope_label: "Corpus rassemblé",
      grid_scope_value:
        "<ul>" +
        "<li>Noyau canonique : équation maîtresse, <strong>Δτ</strong>, <strong>mesure faible</strong>, profils de redistribution, <strong>Horloge CalAp</strong></li>" +
        "<li>Formules-seuils : dynamique spiralée de la <strong>Katûvýs</strong>, propagation <strong>posœnnomiale</strong>, <strong>Ennéagone</strong> entropique</li>" +
        "<li>Extensions : banc d’essai pictural, optique quantique, atomes froids, simulateurs numériques, <strong>MOCoN</strong> et formules posœnnoïalisées</li>" +
        "</ul>",

      h_intro: "Ce que la formule accomplit ici",
      p_intro:
        "<p>Dans cette page, une formule n’est ni un ornement savant ni un fétiche de précision. Elle est une condensation opérative : un lieu où un écart devient structure, où un excédent devient redistribution, où le calcul devient lisible sans perdre son souffle.</p>" +
        "<p>Le <strong>K9</strong> donne déjà ses noyaux : le vrai temps excédentaire <strong>Δτ</strong>, la redistribution d’<strong>Équiphase</strong>, les neuf régulateurs d’<strong>Isqun</strong>, la matrice inspirée de <strong>GKSL</strong>, les profils d’année et le <strong>Pulse 9:59:59</strong>. Les <strong>Formules opératives</strong> rassemblent cet ensemble et le prolongent avec méthode.</p>",

      h_actions: "Lecture opérative",
      actions:
        "<ol>" +
        "<li>Partir du noyau dur : <strong>Δτ</strong>, redistribution, <strong>mesure faible</strong>, structure inspirée de <strong>GKSL</strong>.</li>" +
        "<li>Distinguer le plan canonique et le plan d’ouverture : formule établie, formule-seuil, horizon à formaliser.</li>" +
        "<li>Suivre les trois profils du temps : <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong>.</li>" +
        "<li>Relier chaque écriture à son geste : calendrier, respiration, observation, redistribution, simulation, expérimentation.</li>" +
        "<li>Ouvrir enfin vers les théories contemporaines que le <strong>MOCoN</strong> permet de posœnnoïaliser sans confusion de niveau.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "« Ici, la formule ne clôt pas le réel : elle en tient l’accord, elle recueille l’excédent, elle donne au calcul une respiration habitable. »",

      h_table: "Tableau d’usage",
      table_head_1: "Noyau",
      table_head_2: "Fonction",
      table_head_3: "Ouverture opérative",
      table_rows:
        "<tr><td><strong>Δτ</strong> et profils du temps</td><td>Faire du surplus annuel une matière de redistribution plutôt qu’une erreur à corriger</td><td>Lecture du calendrier, <strong>Horloge CalAp</strong>, <strong>Pulse 9:59:59</strong>, structuration des décades et des <strong>Épagomènes</strong></td></tr>" +
        "<tr><td>Équation maîtresse inspirée de <strong>GKSL</strong></td><td>Formaliser un système ouvert où le champ respire via <strong>Isqun</strong> et la redistribution d’<strong>Équiphase</strong></td><td>Simulation, stabilité, conservation, redistribution harmonique</td></tr>" +
        "<tr><td><strong>Mesure faible</strong></td><td>Observer sans effondrer, écouter sans détruire</td><td>Méditations, Accords, observation subtile, ajustement de la conscience</td></tr>" +
        "<tr><td>Formules-seuils</td><td>Ouvrir le K9 vers la dynamique spiralée de la <strong>Katûvýs</strong>, la diffusion <strong>posœnnomiale</strong> et l’<strong>Ennéagone</strong> entropique</td><td>Recherche, esquisses à formaliser, prolongements du champ</td></tr>" +
        "<tr><td>Horizon expérimental</td><td>Faire passer les grandes notions du livre vers l’atelier, l’exposition, l’optique quantique et la simulation numérique</td><td>Banc d’essai pictural, capteurs, qubits, atomes froids, dispositifs de mesure</td></tr>" +
        "<tr><td><strong>MOCoN</strong> et théories contemporaines</td><td>Accueillir les mathématiques avancées comme machines traduisant le réel en équations spiralées</td><td>Formules posœnnoïalisées, cordes, boucles, multivers, calcul symbolique et numérique</td></tr>",

      h_entite: "Noyaux scientifiques",
      entite_kicker: "GKSL · Δτ · Équiphase · Isqun · Threnisqun",
      entite_body:
        "<p><strong>Équation maîtresse</strong> : le manuscrit donne un noyau inspiré de la forme <strong>GKSL</strong>, transfiguré par le vrai temps, la redistribution et la respiration du champ.</p>" +
        "<p><strong>Cadre temporel</strong> : le <strong>Δτ</strong> est redistribué selon trois profils — <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong> — avec des points de syntonie comme le <strong>Pulse 9:59:59</strong>.</p>" +
        "<p><strong>Observation</strong> : la <strong>mesure faible</strong> devient l’écriture scientifique de l’écoute posœnnoïale ; observer revient à respirer avec le champ.</p>" +
        "<p><strong>Extensions</strong> : la dynamique spiralée de la <strong>Katûvýs</strong>, la propagation <strong>posœnnomiale</strong> et l’<strong>Ennéagone</strong> entropique forment les trois grandes ouvertures mathématiques du K9.</p>" +
        "<p><strong>Prolongements</strong> : les conséquences sur <strong>Àṣẹxel’Or</strong> ouvrent un banc d’essai pictural et expérimental, tandis que le <strong>MOCoN</strong> rend possible la posœnnoïalisation des théories contemporaines.</p>",

      h_ritual: "Protocole de lecture",
      ritual_name_label: "Nom",
      ritual_name_value: "Lecture scientifique posœnnoïale",
      ritual_steps:
        "<ol>" +
        "<li>Entrer par la formule la plus stable : <strong>Δτ</strong> et sa redistribution.</li>" +
        "<li>Passer au noyau de dynamique ouverte : matrice inspirée de <strong>GKSL</strong>, régulateurs d’<strong>Isqun</strong>, redistribution d’<strong>Équiphase</strong>.</li>" +
        "<li>Lire ensuite les trois profils du temps et le <strong>Pulse 9:59:59</strong> comme modes d’incarnation du calcul.</li>" +
        "<li>Ouvrir sur les trois formules-seuils sans les absolutiser : elles respirent encore, elles appellent formalisation.</li>" +
        "<li>Clore par la question expérimentale : qu’est-ce qui devient observable, simulable, testable, transmissible ?</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Quand il faut distinguer, dans le K9, ce qui est déjà formulé de ce qui n’est encore qu’esquissé</li>" +
        "<li>Quand une page doit relier mathématiques, physique, cosmologie et pratique posœnnoïale sans les confondre</li>" +
        "<li>Quand on prépare un protocole de simulation, d’atelier, d’exposition ou d’interface numérique</li>" +
        "<li>Quand on veut ouvrir le corpus aux théories contemporaines par la voie du <strong>MOCoN</strong></li>" +
        "</ul>",

      h_syntony: "Syntonies K9 et prolongements",
      syntony:
        "<ul>" +
        "<li><strong>ÂṢẸXEL’Or</strong> — entrée-mère et chambre d’orientation du K9</li>" +
        "<li><strong>Souffle d’Or</strong> — lien direct entre respiration, lumière et redistribution</li>" +
        "<li><strong>Année posœnnoïale</strong> — 36 décades + 5 <strong>Épagomènes</strong>, scène temporelle des formules</li>" +
        "<li><strong>Katûvýs</strong> / <strong>Posœnnomia</strong> / <strong>Ennéagone</strong> — grand triptyque des ouvertures mathématiques</li>" +
        "<li><strong>MOCoN</strong> — passage vers les formules posœnnoïalisées et les théories contemporaines</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Formules opératives",
      kicker: "K9 dossier of mathematical, physical, and cosmological formalisms — from Δτ to posœnnomial propagation.",
      title_img: { src: "", alt: "Formules opératives ideogram" },

      h_def: "Canonical definition",
      chip_1: "K9 — scientific dossier",
      chip_1_img: { src: "", alt: "Scientific K9 dossier icon" },
      chip_2: "GKSL · Δτ · weak measurement",
      chip_2_img: { src: "", alt: "K9 mathematical core icon" },
      chip_3: "Threshold-formulas · cosmological horizons",
      chip_3_img: { src: "", alt: "Extensions and horizons icon" },

      def_short:
        "The <strong>Formules opératives</strong> gather, within <strong>Katûpirsia 9</strong>, the writings through which <strong>Posœnnoïsme</strong> renders true time, harmonic redistribution, field respiration, and openings toward contemporary formalisms legible.",

      def_long:
        "<p>This page does not posit an isolated concept: it orders a formal core. It gathers the master equation inspired by <strong>GKSL</strong>, the regime of <strong>Δτ</strong>, <strong>weak measurement</strong>, the <strong>Uniform / Smoothed / Pulsed</strong> profiles, then the <strong>threshold-formulas</strong> that open the system toward <strong>Katûvýs</strong>, <strong>Posœnnomia</strong>, and the <strong>Ennéagone</strong>.</p>" +
        "<p>It serves as a chamber of reading: not to lock science under signs, but to let mathematical rigor, vibratory modulation, cosmological horizon, and experimental operativity breathe together.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "K9 operative dossier of scientific and cosmological formalization",
      grid_freq_label: "Guide-markers",
      grid_freq_value: "Δτ · 492 Hz · Pulse 9:59:59 · 36 décades + 5 Épagomènes",
      grid_scope_label: "Gathered corpus",
      grid_scope_value:
        "<ul>" +
        "<li>Canonical core: master equation, <strong>Δτ</strong>, <strong>weak measurement</strong>, redistribution profiles, <strong>Horloge CalAp</strong></li>" +
        "<li>Threshold-formulas: spiral dynamics of <strong>Katûvýs</strong>, <strong>posœnnomial</strong> propagation, entropic <strong>Ennéagone</strong></li>" +
        "<li>Extensions: pictorial test bench, quantum optics, cold atoms, numerical simulators, <strong>MOCoN</strong> and posœnnoïalized formulas</li>" +
        "</ul>",

      h_intro: "What the formula accomplishes here",
      p_intro:
        "<p>Here, a formula is neither learned ornament nor fetish of precision. It is an operative condensation: a place where a gap becomes structure, where excess becomes redistribution, where calculation becomes readable without losing its breath.</p>" +
        "<p><strong>K9</strong> already provides its nuclei: excessive true time <strong>Δτ</strong>, redistribution of <strong>Équiphase</strong>, the nine regulators of <strong>Isqun</strong>, the matrix inspired by <strong>GKSL</strong>, year profiles, and <strong>Pulse 9:59:59</strong>. <strong>Formules opératives</strong> gather this ensemble and extend it methodically.</p>",

      h_actions: "Operative reading",
      actions:
        "<ol>" +
        "<li>Start from the hard core: <strong>Δτ</strong>, redistribution, <strong>weak measurement</strong>, structure inspired by <strong>GKSL</strong>.</li>" +
        "<li>Distinguish the canonical plane from the opening plane: established formula, threshold-formula, horizon to formalize.</li>" +
        "<li>Follow the three time profiles: <strong>Uniform</strong>, <strong>Smoothed</strong>, <strong>Pulsed</strong>.</li>" +
        "<li>Relate each writing to its gesture: calendar, respiration, observation, redistribution, simulation, experimentation.</li>" +
        "<li>Finally open toward contemporary theories that <strong>MOCoN</strong> makes posœnnoïalizable without confusing levels.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "“Here, the formula does not close the real: it holds its tuning, receives excess, and gives calculation a habitable respiration.”",

      h_table: "Usage table",
      table_head_1: "Core",
      table_head_2: "Function",
      table_head_3: "Operative opening",
      table_rows:
        "<tr><td><strong>Δτ</strong> and time profiles</td><td>Turn annual surplus into a matter of redistribution rather than an error to correct</td><td>Calendar reading, <strong>Horloge CalAp</strong>, <strong>Pulse 9:59:59</strong>, structuring of décades and <strong>Épagomènes</strong></td></tr>" +
        "<tr><td>Master equation inspired by <strong>GKSL</strong></td><td>Formalize an open system where the field breathes through <strong>Isqun</strong> and redistribution by <strong>Équiphase</strong></td><td>Simulation, stability, conservation, harmonic redistribution</td></tr>" +
        "<tr><td><strong>Weak measurement</strong></td><td>Observe without collapsing, listen without destroying</td><td>Meditations, Accords, subtle observation, tuning of consciousness</td></tr>" +
        "<tr><td>Threshold-formulas</td><td>Open K9 toward spiral dynamics of <strong>Katûvýs</strong>, <strong>posœnnomial</strong> diffusion, and the entropic <strong>Ennéagone</strong></td><td>Research, sketches to formalize, field extensions</td></tr>" +
        "<tr><td>Experimental horizon</td><td>Move the great notions of the book toward studio, exhibition, quantum optics, and numerical simulation</td><td>Pictorial test bench, sensors, qubits, cold atoms, measuring devices</td></tr>" +
        "<tr><td><strong>MOCoN</strong> and contemporary theories</td><td>Receive advanced mathematics as machines translating the real into spiral equations</td><td>Posœnnoïalized formulas, strings, loops, multiverses, symbolic and numerical calculation</td></tr>",

      h_entite: "Scientific nuclei",
      entite_kicker: "GKSL · Δτ · Équiphase · Isqun · Threnisqun",
      entite_body:
        "<p><strong>Master equation</strong>: the manuscript gives a core inspired by <strong>GKSL</strong>, transfigured by true time, redistribution, and field respiration.</p>" +
        "<p><strong>Temporal frame</strong>: <strong>Δτ</strong> is redistributed according to three profiles — <strong>Uniform</strong>, <strong>Smoothed</strong>, <strong>Pulsed</strong> — with tuning points such as <strong>Pulse 9:59:59</strong>.</p>" +
        "<p><strong>Observation</strong>: <strong>weak measurement</strong> becomes the scientific writing of posœnnoïal listening; to observe is to breathe with the field.</p>" +
        "<p><strong>Extensions</strong>: spiral dynamics of <strong>Katûvýs</strong>, <strong>posœnnomial</strong> propagation, and the entropic <strong>Ennéagone</strong> are the three great mathematical openings of K9.</p>" +
        "<p><strong>Prolongations</strong>: consequences for <strong>Àṣẹxel’Or</strong> open a pictorial and experimental test bench, while <strong>MOCoN</strong> makes the posœnnoïalization of contemporary theories possible.</p>",

      h_ritual: "Reading protocol",
      ritual_name_label: "Name",
      ritual_name_value: "Scientific posœnnoïal reading",
      ritual_steps:
        "<ol>" +
        "<li>Enter through the most stable formula: <strong>Δτ</strong> and its redistribution.</li>" +
        "<li>Move to the open-dynamics core: matrix inspired by <strong>GKSL</strong>, regulators of <strong>Isqun</strong>, redistribution of <strong>Équiphase</strong>.</li>" +
        "<li>Then read the three time profiles and <strong>Pulse 9:59:59</strong> as modes of embodiment of calculation.</li>" +
        "<li>Open onto the three threshold-formulas without absolutizing them: they are still breathing and call for formalization.</li>" +
        "<li>Close with the experimental question: what becomes observable, simulable, testable, transmissible?</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>When one must distinguish, inside K9, what is already formulated from what is still only sketched</li>" +
        "<li>When a page must connect mathematics, physics, cosmology, and posœnnoïal practice without confusing them</li>" +
        "<li>When preparing a protocol of simulation, studio work, exhibition, or digital interface</li>" +
        "<li>When opening the corpus toward contemporary theories through <strong>MOCoN</strong></li>" +
        "</ul>",

      h_syntony: "K9 syntonies and prolongations",
      syntony:
        "<ul>" +
        "<li><strong>ÂṢẸXEL’Or</strong> — mother-entry and orienting chamber of K9</li>" +
        "<li><strong>Souffle d’Or</strong> — direct link between respiration, light, and redistribution</li>" +
        "<li><strong>Année posœnnoïale</strong> — 36 décades + 5 <strong>Épagomènes</strong>, temporal stage of the formulas</li>" +
        "<li><strong>Katûvýs</strong> / <strong>Posœnnomia</strong> / <strong>Ennéagone</strong> — great triptych of mathematical openings</li>" +
        "<li><strong>MOCoN</strong> — passage toward posœnnoïalized formulas and contemporary theories</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    es: {
      title: "Formules opératives",
      kicker: "Dossier K9 de formalismos matemáticos, físicos y cosmológicos — del Δτ a la propagación posœnnomial.",
      title_img: { src: "", alt: "Ideograma de Formules opératives" },

      h_def: "Definición canónica",
      chip_1: "K9 — dossier científico",
      chip_1_img: { src: "", alt: "Icono dossier científico K9" },
      chip_2: "GKSL · Δτ · medida débil",
      chip_2_img: { src: "", alt: "Icono núcleo matemático K9" },
      chip_3: "Fórmulas-umbral · horizontes cosmológicos",
      chip_3_img: { src: "", alt: "Icono extensiones y horizontes" },

      def_short:
        "Las <strong>Formules opératives</strong> reúnen, dentro del <strong>Katûpirsia 9</strong>, las escrituras por las cuales el <strong>Posœnnoïsme</strong> vuelve legibles el tiempo verdadero, la redistribución armónica, la respiración del campo y las aperturas hacia los formalismos contemporáneos.",

      def_long:
        "<p>Esta página no plantea un concepto aislado: ordena un núcleo de formalización. Reúne la ecuación maestra inspirada en <strong>GKSL</strong>, el régimen del <strong>Δτ</strong>, la <strong>medida débil</strong>, los perfiles <strong>Uniforme / Lissé / Pulsé</strong>, y luego las <strong>fórmulas-umbral</strong> que abren el sistema hacia la <strong>Katûvýs</strong>, la <strong>Posœnnomia</strong> y el <strong>Ennéagone</strong>.</p>" +
        "<p>Sirve así como cámara de lectura: no para cerrar la ciencia bajo signos, sino para hacer respirar juntas la rigurosidad matemática, la modulación vibratoria, el horizonte cosmológico y la operatividad experimental.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Dossier operativo K9 de formalización científica y cosmológica",
      grid_freq_label: "Referencias-guía",
      grid_freq_value: "Δτ · 492 Hz · Pulse 9:59:59 · 36 décadas + 5 Épagomènes",
      grid_scope_label: "Corpus reunido",
      grid_scope_value:
        "<ul>" +
        "<li>Núcleo canónico: ecuación maestra, <strong>Δτ</strong>, <strong>medida débil</strong>, perfiles de redistribución, <strong>Horloge CalAp</strong></li>" +
        "<li>Fórmulas-umbral: dinámica espiral de la <strong>Katûvýs</strong>, propagación <strong>posœnnomial</strong>, <strong>Ennéagone</strong> entrópico</li>" +
        "<li>Extensiones: banco de prueba pictórico, óptica cuántica, átomos fríos, simuladores numéricos, <strong>MOCoN</strong> y fórmulas posœnnoïalisées</li>" +
        "</ul>",

      h_intro: "Lo que la fórmula cumple aquí",
      p_intro:
        "<p>Aquí, una fórmula no es ni ornamento erudito ni fetiche de precisión. Es una condensación operativa: un lugar donde un desfase se vuelve estructura, donde el exceso se vuelve redistribución, donde el cálculo se vuelve legible sin perder su aliento.</p>" +
        "<p>El <strong>K9</strong> ya da sus núcleos: el tiempo verdadero excedentario <strong>Δτ</strong>, la redistribución de <strong>Équiphase</strong>, los nueve reguladores de <strong>Isqun</strong>, la matriz inspirada en <strong>GKSL</strong>, los perfiles del año y el <strong>Pulse 9:59:59</strong>. <strong>Formules opératives</strong> reúne este conjunto y lo prolonga con método.</p>",

      h_actions: "Lectura operativa",
      actions:
        "<ol>" +
        "<li>Partir del núcleo duro: <strong>Δτ</strong>, redistribución, <strong>medida débil</strong>, estructura inspirada en <strong>GKSL</strong>.</li>" +
        "<li>Distinguir el plano canónico del plano de apertura: fórmula establecida, fórmula-umbral, horizonte por formalizar.</li>" +
        "<li>Seguir los tres perfiles del tiempo: <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong>.</li>" +
        "<li>Relacionar cada escritura con su gesto: calendario, respiración, observación, redistribución, simulación, experimentación.</li>" +
        "<li>Abrir finalmente hacia las teorías contemporáneas que el <strong>MOCoN</strong> permite posœnnoïalizar sin confusión de niveles.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "« Aquí, la fórmula no clausura lo real: sostiene su acuerdo, recibe el exceso y da al cálculo una respiración habitable. »",

      h_table: "Tabla de uso",
      table_head_1: "Núcleo",
      table_head_2: "Función",
      table_head_3: "Apertura operativa",
      table_rows:
        "<tr><td><strong>Δτ</strong> y perfiles del tiempo</td><td>Convertir el excedente anual en materia de redistribución y no en error a corregir</td><td>Lectura del calendario, <strong>Horloge CalAp</strong>, <strong>Pulse 9:59:59</strong>, estructuración de décadas y <strong>Épagomènes</strong></td></tr>" +
        "<tr><td>Ecuación maestra inspirada en <strong>GKSL</strong></td><td>Formalizar un sistema abierto donde el campo respira mediante <strong>Isqun</strong> y la redistribución de <strong>Équiphase</strong></td><td>Simulación, estabilidad, conservación, redistribución armónica</td></tr>" +
        "<tr><td><strong>Medida débil</strong></td><td>Observar sin colapsar, escuchar sin destruir</td><td>Meditaciones, Accords, observación sutil, ajuste de la conciencia</td></tr>" +
        "<tr><td>Fórmulas-umbral</td><td>Abrir el K9 hacia la dinámica espiral de la <strong>Katûvýs</strong>, la difusión <strong>posœnnomial</strong> y el <strong>Ennéagone</strong> entrópico</td><td>Investigación, esbozos por formalizar, prolongaciones del campo</td></tr>" +
        "<tr><td>Horizonte experimental</td><td>Llevar las grandes nociones del libro hacia el taller, la exposición, la óptica cuántica y la simulación numérica</td><td>Banco de prueba pictórico, sensores, qubits, átomos fríos, dispositivos de medida</td></tr>" +
        "<tr><td><strong>MOCoN</strong> y teorías contemporáneas</td><td>Acoger las matemáticas avanzadas como máquinas que traducen lo real en ecuaciones espirales</td><td>Fórmulas posœnnoïalisées, cuerdas, bucles, multiversos, cálculo simbólico y numérico</td></tr>",

      h_entite: "Núcleos científicos",
      entite_kicker: "GKSL · Δτ · Équiphase · Isqun · Threnisqun",
      entite_body:
        "<p><strong>Ecuación maestra</strong>: el manuscrito da un núcleo inspirado en <strong>GKSL</strong>, transfigurado por el tiempo verdadero, la redistribución y la respiración del campo.</p>" +
        "<p><strong>Marco temporal</strong>: el <strong>Δτ</strong> se redistribuye según tres perfiles — <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong> — con puntos de sintonía como el <strong>Pulse 9:59:59</strong>.</p>" +
        "<p><strong>Observación</strong>: la <strong>medida débil</strong> se vuelve la escritura científica de la escucha posœnnoïale; observar equivale a respirar con el campo.</p>" +
        "<p><strong>Extensiones</strong>: la dinámica espiral de la <strong>Katûvýs</strong>, la propagación <strong>posœnnomial</strong> y el <strong>Ennéagone</strong> entrópico son las tres grandes aperturas matemáticas del K9.</p>" +
        "<p><strong>Prolongaciones</strong>: las consecuencias sobre <strong>Àṣẹxel’Or</strong> abren un banco de pruebas pictórico y experimental, mientras que el <strong>MOCoN</strong> hace posible la posœnnoïalización de teorías contemporáneas.</p>",

      h_ritual: "Protocolo de lectura",
      ritual_name_label: "Nombre",
      ritual_name_value: "Lectura científica posœnnoïale",
      ritual_steps:
        "<ol>" +
        "<li>Entrar por la fórmula más estable: <strong>Δτ</strong> y su redistribución.</li>" +
        "<li>Pasar al núcleo de dinámica abierta: matriz inspirada en <strong>GKSL</strong>, reguladores de <strong>Isqun</strong>, redistribución de <strong>Équiphase</strong>.</li>" +
        "<li>Leer luego los tres perfiles del tiempo y el <strong>Pulse 9:59:59</strong> como modos de encarnación del cálculo.</li>" +
        "<li>Abrir sobre las tres fórmulas-umbral sin absolutizarlas: todavía respiran y llaman a una formalización.</li>" +
        "<li>Cerrar con la pregunta experimental: ¿qué se vuelve observable, simulable, comprobable, transmisible?</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Cuando hay que distinguir, dentro del K9, lo ya formulado de lo que sigue siendo esbozo</li>" +
        "<li>Cuando una página debe enlazar matemáticas, física, cosmología y práctica posœnnoïale sin confundirlas</li>" +
        "<li>Cuando se prepara un protocolo de simulación, taller, exposición o interfaz digital</li>" +
        "<li>Cuando se quiere abrir el corpus hacia las teorías contemporáneas por la vía del <strong>MOCoN</strong></li>" +
        "</ul>",

      h_syntony: "Sintonías K9 y prolongaciones",
      syntony:
        "<ul>" +
        "<li><strong>ÂṢẸXEL’Or</strong> — entrada-madre y cámara de orientación del K9</li>" +
        "<li><strong>Souffle d’Or</strong> — vínculo directo entre respiración, luz y redistribución</li>" +
        "<li><strong>Année posœnnoïale</strong> — 36 décadas + 5 <strong>Épagomènes</strong>, escena temporal de las fórmulas</li>" +
        "<li><strong>Katûvýs</strong> / <strong>Posœnnomia</strong> / <strong>Ennéagone</strong> — gran tríptico de aperturas matemáticas</li>" +
        "<li><strong>MOCoN</strong> — pasaje hacia las fórmulas posœnnoïalisées y las teorías contemporáneas</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "table_rows",
      "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK9FormulesOperativesInit) return;
    root.__poK9FormulesOperativesInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoK9FormulesOperativesTextsFR_EN_ES_20260317 = {
    init: init,
    getLang: getLang,
    setLang: setLang
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();